import { jsx as _jsx } from "react/jsx-runtime";
import { BASE_CONF } from "./config.js";
const Grid = ({ children, className = '', 'data-testid': dataTestId, fluid = false }) => {
    const style = {
        width: '100%',
        marginRight: 'auto',
        marginLeft: 'auto',
        paddingRight: `${BASE_CONF.outerMargin}rem`,
        paddingLeft: `${BASE_CONF.outerMargin}rem`,
        boxSizing: 'border-box',
    };
    // For non-fluid grids, add max-width based on breakpoints
    if (!fluid) {
        style.maxWidth = `${BASE_CONF.container.lg}rem`;
    }
    return (_jsx("div", { className: className, "data-testid": dataTestId, style: style, children: children }));
};
Grid.displayName = 'Grid';
export default Grid;
//# sourceMappingURL=grid.js.map